import { FormEvent, useState, useContext } from 'react';
import * as C from './styles';
import { AuthContext } from '../../contexts/auth/AuthContext';

import { populateLocalStorage } from '../../helpers/fakerBackEnd';

const Login = () => {
  populateLocalStorage();
  const auth = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('1234');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showHelp, setShowHelp] = useState(true);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    if (email && password) {
      const isLogged = await auth.signin(email, password);
      if (isLogged) {
        setLoading(false);
        window.location.href = '/xarerp';
      } else {
        setLoading(false);
        setError(true);
      }
    }
  }

  return (
    <C.Container>
      <C.LoginCard>
        <C.Title>
          Login
        </C.Title>
        <C.Description>
          Acesse sua conta para continuar
        </C.Description>

        <C.Form onSubmit={handleSubmit}>
          <C.Input
            type='email'
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder='E-mail'
            disabled={loading}
            required
          />

          {error &&
            <C.Error>
              E-mail inválido.
            </C.Error>
          }

          <C.Button
            disabled={loading}
          >
            Entrar
          </C.Button>
        </C.Form>

      </C.LoginCard>

      <C.ShowHelp onClick={() => setShowHelp(!showHelp)}>
        Exibir ajudar
      </C.ShowHelp>

      {showHelp
        &&
        <C.AlertOnLogin>
          <button onClick={() => setShowHelp(false)}>x</button>
          <p>Essa é apenas uma versão demonstrativa do Front-end, todos os dados ficarão salvos somente no seu navegador e algumas informaçãos, gráficos, paginação e pesquisa serão limitados.</p>
          <p>Para obter a versão completa, acesse: <a href="https://github.com/danielmafra" target="_blank" rel="noreferrer">GitHub</a> ou entre em contato: <a href="https://instagram.com/danielmafradev" target="_blank" rel="noreferrer">Instagram</a></p>

          <C.Credentials>
            <p>Utilize um dos e-mails abaixo para continuar:</p>
            <ul>
              <li
                onClick={() => setEmail('administracao@mail.com')}
              >administracao@mail.com</li>
              <li
                onClick={() => setEmail('financeiro@mail.com')}
              >financeiro@mail.com</li>
              <li
                onClick={() => setEmail('vendas@mail.com')}
              >vendas@mail.com</li>
              <li
                onClick={() => setEmail('deposito@mail.com')}
              >deposito@mail.com</li>
            </ul>
            <p>*Cada credencial possui suas respectivas permissões de acesso.</p>
          </C.Credentials>
        </C.AlertOnLogin>}
    </C.Container>
  )
}

export default Login;
